/** Storage access that never throws (private mode, blocked site data). */
export const safeStorage = {
  get(kind: 'local' | 'session', key: string): string | null {
    try {
      return (kind === 'local' ? localStorage : sessionStorage).getItem(key);
    } catch {
      return null;
    }
  },
  set(kind: 'local' | 'session', key: string, value: string): void {
    try {
      (kind === 'local' ? localStorage : sessionStorage).setItem(key, value);
    } catch {
      /* storage unavailable: feature degrades to in-memory */
    }
  },
  remove(kind: 'local' | 'session', key: string): void {
    try {
      (kind === 'local' ? localStorage : sessionStorage).removeItem(key);
    } catch {
      /* ignore */
    }
  },
};

export function randomClientId(): string {
  const bytes = new Uint8Array(12);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}
